const WORKFLOW_DND_ID_PREFIX = 'workflow-' as const;
const COLUMN_DND_ID_PREFIX = 'column-' as const;

export type WorkflowDndId = `${typeof WORKFLOW_DND_ID_PREFIX}${string}`;
export type ColumnDndId = `${typeof COLUMN_DND_ID_PREFIX}${string}`;

export function getWorkflowDndId(workflowId: string): WorkflowDndId {
  return `${WORKFLOW_DND_ID_PREFIX}${workflowId}`;
}

export function getColumnDndId(columnId: string): ColumnDndId {
  return `${COLUMN_DND_ID_PREFIX}${columnId}`;
}

export function getIsWorkflowDndId(id: string): id is WorkflowDndId {
  return id.startsWith(WORKFLOW_DND_ID_PREFIX);
}

export function getIsColumnDndId(id: string): id is ColumnDndId {
  return id.startsWith(COLUMN_DND_ID_PREFIX);
}

export function parseColumnIdFromDndId(id: ColumnDndId): string;
export function parseColumnIdFromDndId(id: string): string | null;
export function parseColumnIdFromDndId(id: string): string | null {
  if (!getIsColumnDndId(id)) return null;
  return id.slice(COLUMN_DND_ID_PREFIX.length);
}
